import { IAttribute, IAttributeGroup, IAttributeUnit, ICountry, IRegion, IYear } from "../types";

export const attributeGroups: IAttributeGroup[] = [
  { id: 1, name: "Noncommunicable Diseases" },
  { id: 2, name: "Environmental Factors and Affects" },
  { id: 3, name: "Immunization & Communicable Diseases" },
];

export const attributeUnits: IAttributeUnit[] = [
  { id: 1, name: "Percentage" },
  { id: 2, name: "per 100,000" },
  { id: 3, name: "ppm" },
  { id: 4, name: "Number of Cases" },
];

export const attributes: IAttribute[] = [
  { id: 1, attributeGroupId: 1, name: "Obesity, Children (5-9 yr)", unitId: 1 },
  { id: 2, attributeGroupId: 1, name: "Obesity, Children (5-9 yr), Female", unitId: 1 },
  { id: 3, attributeGroupId: 1, name: "Obesity, Children (5-9 yr), Male", unitId: 1 },
  { id: 4, attributeGroupId: 1, name: "Obesity, Adolescents (10-19 yr)", unitId: 1 },
  { id: 5, attributeGroupId: 1, name: "Obesity, Adolescents (10-19 yr), Female", unitId: 1 },
  { id: 6, attributeGroupId: 1, name: "Obesity, Adolescents (10-19 yr), Male", unitId: 1 },
  { id: 7, attributeGroupId: 1, name: "Obesity, Adults (18+ yr)", unitId: 1 },
  { id: 8, attributeGroupId: 1, name: "Obesity, Adults (18+ yr), Female", unitId: 1 },
  { id: 9, attributeGroupId: 1, name: "Obesity, Adults (18+ yr), Male", unitId: 1 },
  { id: 10, attributeGroupId: 1, name: "Diabetes, Adults (18+)", unitId: 1 },
  { id: 11, attributeGroupId: 1, name: "Diabetes, Adults (18+), Female", unitId: 1 },
  { id: 12, attributeGroupId: 1, name: "Diabetes, Adults (18+), Male", unitId: 1 },
  { id: 13, attributeGroupId: 1, name: "Hypertension, Adults (30+)", unitId: 1 },
  { id: 14, attributeGroupId: 1, name: "Hypertension, Adults (30+), Female", unitId: 1 },
  { id: 15, attributeGroupId: 1, name: "Hypertension, Adults (30+), Male", unitId: 1 },
  { id: 16, attributeGroupId: 1, name: "Cancer Deaths", unitId: 2 },
  { id: 17, attributeGroupId: 1, name: "Cancer Deaths, Female", unitId: 2 },
  { id: 18, attributeGroupId: 1, name: "Cancer Deaths, Male", unitId: 2 },
  { id: 19, attributeGroupId: 1, name: "Diabetes Deaths", unitId: 2 },
  { id: 20, attributeGroupId: 1, name: "Diabetes Deaths, Female", unitId: 2 },
  { id: 21, attributeGroupId: 1, name: "Diabetes Deaths, Male", unitId: 2 },
  { id: 22, attributeGroupId: 1, name: "Cardiovascular Disease Deaths", unitId: 2 },
  { id: 23, attributeGroupId: 1, name: "Cardiovascular Disease Deaths, Female", unitId: 2 },
  { id: 24, attributeGroupId: 1, name: "Cardiovascular Disease Deaths, Male", unitId: 2 },
  { id: 25, attributeGroupId: 1, name: "Asthma Deaths", unitId: 2 },
  { id: 26, attributeGroupId: 1, name: "Asthma Deaths, Female", unitId: 2 },
  { id: 27, attributeGroupId: 1, name: "Asthma Deaths, Male", unitId: 2 },
  { id: 28, attributeGroupId: 2, name: "Air Pollution, PM2.5", unitId: 3 },
  { id: 29, attributeGroupId: 2, name: "Air Pollution, PM2.5, City", unitId: 3 },
  { id: 30, attributeGroupId: 2, name: "Air Pollution, PM2.5, Town", unitId: 3 },
  { id: 31, attributeGroupId: 2, name: "Air Pollution, PM2.5, Rural", unitId: 3 },
  { id: 32, attributeGroupId: 2, name: "Air Pollution Deaths", unitId: 2 },
  { id: 33, attributeGroupId: 2, name: "Air Pollution Deaths, Female", unitId: 2 },
  { id: 34, attributeGroupId: 2, name: "Air Pollution Deaths, Male", unitId: 2 },
  { id: 35, attributeGroupId: 2, name: "Drinking Water (Safely Managed)", unitId: 1 },
  { id: 36, attributeGroupId: 2, name: "Drinking Water (Safely Managed), Urban", unitId: 1 },
  { id: 37, attributeGroupId: 2, name: "Drinking Water (Safely Managed), Rural", unitId: 1 },
  { id: 38, attributeGroupId: 2, name: "Diarrhea Deaths", unitId: 1 },
  { id: 39, attributeGroupId: 2, name: "Diarrhea Deaths, Female", unitId: 1 },
  { id: 40, attributeGroupId: 2, name: "Diarrhea Deaths, Male", unitId: 1 },
  { id: 41, attributeGroupId: 2, name: "Diarrhea Deaths, Children (0-4 yr)", unitId: 1 },
  { id: 42, attributeGroupId: 3, name: "Polio Vaccination", unitId: 1 },
  { id: 43, attributeGroupId: 3, name: "Tuberculosis (BCG) Vaccination", unitId: 1 },
  { id: 44, attributeGroupId: 3, name: "Measles (including MMR) Vaccination", unitId: 1 },
  { id: 45, attributeGroupId: 3, name: "Measles Cases", unitId: 4 },
  { id: 46, attributeGroupId: 3, name: "Polio Cases", unitId: 4 },
  { id: 47, attributeGroupId: 3, name: "Mumps Cases", unitId: 4 },
  { id: 48, attributeGroupId: 3, name: "Tuberculosis Deaths", unitId: 2 },
  { id: 49, attributeGroupId: 3, name: "Tuberculosis Deaths, Female", unitId: 2 },
  { id: 50, attributeGroupId: 3, name: "Tuberculosis Deaths, Male", unitId: 2 },
];

export const regions: IRegion[] = [
  { id: 1, name: "African Region" },
  { id: 2, name: "Eastern Mediterranean Region" },
  { id: 3, name: "European Region" },
  { id: 4, name: "Region of the Americas" },
  { id: 5, name: "South-East Asian Region" },
  { id: 6, name: "Western Pacific Region" },
];

export const countries: ICountry[] = [
  { id: 1, name: "Algeria", regionId: 1 },
  { id: 2, name: "Angola", regionId: 1 },
  { id: 3, name: "Benin", regionId: 1 },
  { id: 4, name: "Botswana", regionId: 1 },
  { id: 5, name: "Burkina Faso", regionId: 1 },
  { id: 6, name: "Burundi", regionId: 1 },
  { id: 7, name: "Cabo Verde", regionId: 1 },
  { id: 8, name: "Cameroon", regionId: 1 },
  { id: 9, name: "Central African Republic", regionId: 1 },
  { id: 10, name: "Chad", regionId: 1 },
  { id: 11, name: "Comoros", regionId: 1 },
  { id: 12, name: "Congo", regionId: 1 },
  { id: 13, name: "Côte d'Ivoire", regionId: 1 },
  { id: 14, name: "Democratic Republic of the Congo", regionId: 1 },
  { id: 15, name: "Equatorial Guinea", regionId: 1 },
  { id: 16, name: "Eritrea", regionId: 1 },
  { id: 17, name: "Eswatini", regionId: 1 },
  { id: 18, name: "Ethiopia", regionId: 1 },
  { id: 19, name: "Gabon", regionId: 1 },
  { id: 20, name: "Gambia", regionId: 1 },
  { id: 21, name: "Ghana", regionId: 1 },
  { id: 22, name: "Guinea", regionId: 1 },
  { id: 23, name: "Guinea-Bissau", regionId: 1 },
  { id: 24, name: "Kenya", regionId: 1 },
  { id: 25, name: "Lesotho", regionId: 1 },
  { id: 26, name: "Liberia", regionId: 1 },
  { id: 27, name: "Madagascar", regionId: 1 },
  { id: 28, name: "Malawi", regionId: 1 },
  { id: 29, name: "Mali", regionId: 1 },
  { id: 30, name: "Mauritania", regionId: 1 },
  { id: 31, name: "Mauritius", regionId: 1 },
  { id: 32, name: "Mozambique", regionId: 1 },
  { id: 33, name: "Namibia", regionId: 1 },
  { id: 34, name: "Niger", regionId: 1 },
  { id: 35, name: "Nigeria", regionId: 1 },
  { id: 36, name: "Rwanda", regionId: 1 },
  { id: 37, name: "Sao Tome and Principe", regionId: 1 },
  { id: 38, name: "Senegal", regionId: 1 },
  { id: 39, name: "Seychelles", regionId: 1 },
  { id: 40, name: "Sierra Leone", regionId: 1 },
  { id: 41, name: "South Africa", regionId: 1 },
  { id: 42, name: "South Sudan", regionId: 1 },
  { id: 43, name: "Sudan (former)", regionId: 1 },
  { id: 44, name: "Togo", regionId: 1 },
  { id: 45, name: "Uganda", regionId: 1 },
  { id: 46, name: "United Republic of Tanzania", regionId: 1 },
  { id: 47, name: "Zambia", regionId: 1 },
  { id: 48, name: "Zimbabwe", regionId: 1 },
  { id: 49, name: "Afghanistan", regionId: 2 },
  { id: 50, name: "Bahrain", regionId: 2 },
  { id: 51, name: "Djibouti", regionId: 2 },
  { id: 52, name: "Egypt", regionId: 2 },
  { id: 53, name: "Iran (Islamic Republic of)", regionId: 2 },
  { id: 54, name: "Iraq", regionId: 2 },
  { id: 55, name: "Jordan", regionId: 2 },
  { id: 56, name: "Kuwait", regionId: 2 },
  { id: 57, name: "Lebanon", regionId: 2 },
  { id: 58, name: "Libya", regionId: 2 },
  { id: 59, name: "Morocco", regionId: 2 },
  { id: 60, name: "Oman", regionId: 2 },
  { id: 61, name: "Pakistan", regionId: 2 },
  { id: 62, name: "Qatar", regionId: 2 },
  { id: 63, name: "Saudi Arabia", regionId: 2 },
  { id: 64, name: "Somalia", regionId: 2 },
  { id: 65, name: "Sudan", regionId: 2 },
  { id: 66, name: "Syrian Arab Republic", regionId: 2 },
  { id: 67, name: "Tunisia", regionId: 2 },
  { id: 68, name: "United Arab Emirates", regionId: 2 },
  { id: 69, name: "Yemen", regionId: 2 },
  { id: 70, name: "Albania", regionId: 3 },
  { id: 71, name: "Andorra", regionId: 3 },
  { id: 72, name: "Armenia", regionId: 3 },
  { id: 73, name: "Austria", regionId: 3 },
  { id: 74, name: "Azerbaijan", regionId: 3 },
  { id: 75, name: "Belarus", regionId: 3 },
  { id: 76, name: "Belgium", regionId: 3 },
  { id: 77, name: "Bosnia and Herzegovina", regionId: 3 },
  { id: 78, name: "Bulgaria", regionId: 3 },
  { id: 79, name: "Croatia", regionId: 3 },
  { id: 80, name: "Cyprus", regionId: 3 },
  { id: 81, name: "Czechia", regionId: 3 },
  { id: 82, name: "Denmark", regionId: 3 },
  { id: 83, name: "Estonia", regionId: 3 },
  { id: 84, name: "Finland", regionId: 3 },
  { id: 85, name: "France", regionId: 3 },
  { id: 86, name: "Georgia", regionId: 3 },
  { id: 87, name: "Germany", regionId: 3 },
  { id: 88, name: "Greece", regionId: 3 },
  { id: 89, name: "Hungary", regionId: 3 },
  { id: 90, name: "Iceland", regionId: 3 },
  { id: 91, name: "Ireland", regionId: 3 },
  { id: 92, name: "Israel", regionId: 3 },
  { id: 93, name: "Italy", regionId: 3 },
  { id: 94, name: "Kazakhstan", regionId: 3 },
  { id: 95, name: "Kyrgyzstan", regionId: 3 },
  { id: 96, name: "Latvia", regionId: 3 },
  { id: 97, name: "Lithuania", regionId: 3 },
  { id: 98, name: "Luxembourg", regionId: 3 },
  { id: 99, name: "Malta", regionId: 3 },
  { id: 100, name: "Monaco", regionId: 3 },
  { id: 101, name: "Montenegro", regionId: 3 },
  { id: 102, name: "Netherlands (Kingdom of the)", regionId: 3 },
  { id: 103, name: "North Macedonia", regionId: 3 },
  { id: 104, name: "Norway", regionId: 3 },
  { id: 105, name: "Poland", regionId: 3 },
  { id: 106, name: "Portugal", regionId: 3 },
  { id: 107, name: "Republic of Moldova", regionId: 3 },
  { id: 108, name: "Romania", regionId: 3 },
  { id: 109, name: "Russian Federation", regionId: 3 },
  { id: 110, name: "San Marino", regionId: 3 },
  { id: 111, name: "Serbia", regionId: 3 },
  { id: 112, name: "Slovakia", regionId: 3 },
  { id: 113, name: "Slovenia", regionId: 3 },
  { id: 114, name: "Spain", regionId: 3 },
  { id: 115, name: "Sweden", regionId: 3 },
  { id: 116, name: "Switzerland", regionId: 3 },
  { id: 117, name: "Tajikistan", regionId: 3 },
  { id: 118, name: "Türkiye", regionId: 3 },
  { id: 119, name: "Turkmenistan", regionId: 3 },
  { id: 120, name: "Ukraine", regionId: 3 },
  { id: 121, name: "United Kingdom of Great Britain and Northern Ireland", regionId: 3 },
  { id: 122, name: "Uzbekistan", regionId: 3 },
  { id: 123, name: "Antigua and Barbuda", regionId: 4 },
  { id: 124, name: "Argentina", regionId: 4 },
  { id: 125, name: "Bahamas", regionId: 4 },
  { id: 126, name: "Barbados", regionId: 4 },
  { id: 127, name: "Belize", regionId: 4 },
  { id: 128, name: "Bolivia (Plurinational State of)", regionId: 4 },
  { id: 129, name: "Brazil", regionId: 4 },
  { id: 130, name: "Canada", regionId: 4 },
  { id: 131, name: "Chile", regionId: 4 },
  { id: 132, name: "Colombia", regionId: 4 },
  { id: 133, name: "Costa Rica", regionId: 4 },
  { id: 134, name: "Cuba", regionId: 4 },
  { id: 135, name: "Dominica", regionId: 4 },
  { id: 136, name: "Dominican Republic", regionId: 4 },
  { id: 137, name: "Ecuador", regionId: 4 },
  { id: 138, name: "El Salvador", regionId: 4 },
  { id: 139, name: "Grenada", regionId: 4 },
  { id: 140, name: "Guatemala", regionId: 4 },
  { id: 141, name: "Guyana", regionId: 4 },
  { id: 142, name: "Haiti", regionId: 4 },
  { id: 143, name: "Honduras", regionId: 4 },
  { id: 144, name: "Jamaica", regionId: 4 },
  { id: 145, name: "Mexico", regionId: 4 },
  { id: 146, name: "Nicaragua", regionId: 4 },
  { id: 147, name: "Panama", regionId: 4 },
  { id: 148, name: "Paraguay", regionId: 4 },
  { id: 149, name: "Peru", regionId: 4 },
  { id: 150, name: "Saint Kitts and Nevis", regionId: 4 },
  { id: 151, name: "Saint Lucia", regionId: 4 },
  { id: 152, name: "Saint Vincent and the Grenadines", regionId: 4 },
  { id: 153, name: "Suriname", regionId: 4 },
  { id: 154, name: "Trinidad and Tobago", regionId: 4 },
  { id: 155, name: "United States of America", regionId: 4 },
  { id: 156, name: "Uruguay", regionId: 4 },
  { id: 157, name: "Venezuela (Bolivarian Republic of)", regionId: 4 },
  { id: 158, name: "Bangladesh", regionId: 5 },
  { id: 159, name: "Bhutan", regionId: 5 },
  { id: 160, name: "Democratic People's Republic of Korea", regionId: 5 },
  { id: 161, name: "India", regionId: 5 },
  { id: 162, name: "Indonesia", regionId: 5 },
  { id: 163, name: "Maldives", regionId: 5 },
  { id: 164, name: "Myanmar", regionId: 5 },
  { id: 165, name: "Nepal", regionId: 5 },
  { id: 166, name: "Sri Lanka", regionId: 5 },
  { id: 167, name: "Thailand", regionId: 5 },
  { id: 168, name: "Timor-Leste", regionId: 5 },
  { id: 169, name: "Australia", regionId: 6 },
  { id: 170, name: "Brunei Darussalam", regionId: 6 },
  { id: 171, name: "Cambodia", regionId: 6 },
  { id: 172, name: "China", regionId: 6 },
  { id: 173, name: "Cook Islands", regionId: 6 },
  { id: 174, name: "Fiji", regionId: 6 },
  { id: 175, name: "Japan", regionId: 6 },
  { id: 176, name: "Kiribati", regionId: 6 },
  { id: 177, name: "Lao People's Democratic Republic", regionId: 6 },
  { id: 178, name: "Malaysia", regionId: 6 },
  { id: 179, name: "Marshall Islands", regionId: 6 },
  { id: 180, name: "Micronesia (Federated States of)", regionId: 6 },
  { id: 181, name: "Mongolia", regionId: 6 },
  { id: 182, name: "Nauru", regionId: 6 },
  { id: 183, name: "New Zealand", regionId: 6 },
  { id: 184, name: "Niue", regionId: 6 },
  { id: 185, name: "Palau", regionId: 6 },
  { id: 186, name: "Papua New Guinea", regionId: 6 },
  { id: 187, name: "Philippines", regionId: 6 },
  { id: 188, name: "Republic of Korea", regionId: 6 },
  { id: 189, name: "Samoa", regionId: 6 },
  { id: 190, name: "Singapore", regionId: 6 },
  { id: 191, name: "Solomon Islands", regionId: 6 },
  { id: 192, name: "Tonga", regionId: 6 },
  { id: 193, name: "Tuvalu", regionId: 6 },
  { id: 194, name: "Vanuatu", regionId: 6 },
  { id: 195, name: "Viet Nam", regionId: 6 },
];

export const years: IYear[] = [
  { id: 1, name: "2022" },
  { id: 2, name: "2021" },
  { id: 3, name: "2020" },
  { id: 4, name: "2019" },
  { id: 5, name: "2018" },
  { id: 6, name: "2017" },
  { id: 7, name: "2016" },
  { id: 8, name: "2015" },
  { id: 9, name: "2014" },
  { id: 10, name: "2013" },
  { id: 11, name: "2012" },
  { id: 12, name: "2011" },
  { id: 13, name: "2010" },
  { id: 14, name: "2009" },
  { id: 15, name: "2008" },
  { id: 16, name: "2007" },
  { id: 17, name: "2006" },
  { id: 18, name: "2005" },
  { id: 19, name: "2004" },
  { id: 20, name: "2003" },
  { id: 21, name: "2002" },
  { id: 22, name: "2001" },
  { id: 23, name: "2000" },
  { id: 24, name: "1999" },
  { id: 25, name: "1998" },
  { id: 26, name: "1997" },
  { id: 27, name: "1996" },
  { id: 28, name: "1995" },
  { id: 29, name: "1994" },
  { id: 30, name: "1993" },
  { id: 31, name: "1992" },
  { id: 32, name: "1991" },
  { id: 33, name: "1990" },
];
